// extracted by css-extract-rspack-plugin
export default {"cls1":"download_preflight-cls1_fJp","cls2":"download_preflight-cls2_9ic download_preflight-cls1_fJp","dp-check-pop":"download_preflight-dp-check-pop_siK"};